// Russian-language helpers used across screens.

export function pluralRu(n: number, [one, few, many]: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function daysWord(n: number): string {
  return pluralRu(n, ['день', 'дня', 'дней']);
}

const SHORT_MONTHS_RU = [
  'янв', 'фев', 'мар', 'апр', 'май', 'июн',
  'июл', 'авг', 'сен', 'окт', 'ноя', 'дек',
];

// Full prepositional ("с марта 2026"), used in the profile screen identity row.
const MONTHS_RU_PREP = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

// "с марта 2026" — used under the user's identity on the profile screen.
// Returns empty string for unparseable input so the caller can decide whether
// to show the divider dot.
export function formatMemberSince(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `с ${MONTHS_RU_PREP[d.getMonth()]} ${d.getFullYear()}`;
}

// Whole-day count since the given ISO timestamp; clamped at 0. Used for the
// "ты с нами уже X дней" stat. Floor (not ceil) so day-of-signup reads "0".
export function daysSince(iso: string, now: Date = new Date()): number {
  if (!iso) return 0;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 0;
  const diffMs = now.getTime() - d.getTime();
  if (diffMs <= 0) return 0;
  return Math.floor(diffMs / 86_400_000);
}

export function formatExpiresShort(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getDate()} ${SHORT_MONTHS_RU[d.getMonth()]} ${d.getFullYear()}`;
}

const VLESS_RE = /^vless:\/\/([^@]+)@([^:?]+)(:\d+)?/;

// Trim a long subscription URL to a fingerprint for display, preserving the
// scheme prefix and host so it still reads like a key.
export function truncateLink(link: string): string {
  if (!link) return '';
  const m = link.match(VLESS_RE);
  if (m) {
    const id = m[1];
    const host = m[2];
    const head = id.length > 6 ? `${id.slice(0, 6)}...${id.slice(-12)}` : id;
    return `vless://${head}@${host}`;
  }
  if (link.length <= 56) return link;
  return `${link.slice(0, 28)}...${link.slice(-24)}`;
}

export function hostFromLink(link: string, fallback = 'shush.cloud'): string {
  const m = link.match(VLESS_RE);
  if (m) return m[2];
  try {
    return new URL(link).host;
  } catch {
    return fallback;
  }
}
